import React from 'react';

const MapPin = ({ width = 17, height = 17 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_2388_7198)">
      <path
        d="M2.74088 12.0078L1.08008 15.8846H15.4801L13.8193 12.0078"
        stroke="#333333"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.28015 12.8348C8.28015 12.8348 13.325 9.68277 13.325 6.52917C13.325 5.19121 12.7934 3.90805 11.8474 2.96196C10.9013 2.01588 9.61812 1.48438 8.28015 1.48438C6.94219 1.48438 5.65902 2.01588 4.71294 2.96196C3.76686 3.90805 3.23535 5.19121 3.23535 6.52917C3.23535 9.68117 8.28015 12.8348 8.28015 12.8348Z"
        stroke="#333333"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.28066 6.46855C8.12153 6.46855 7.96892 6.40534 7.8564 6.29282C7.74388 6.1803 7.68066 6.02768 7.68066 5.86855C7.68066 5.70942 7.74388 5.55681 7.8564 5.44429C7.96892 5.33177 8.12153 5.26855 8.28066 5.26855"
        stroke="#333333"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.28027 6.46855C8.4394 6.46855 8.59202 6.40534 8.70454 6.29282C8.81706 6.1803 8.88027 6.02768 8.88027 5.86855C8.88027 5.70942 8.81706 5.55681 8.70454 5.44429C8.59202 5.33177 8.4394 5.26855 8.28027 5.26855"
        stroke="#333333"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2388_7198">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.280273 0.68457)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default MapPin;
